import React__default from 'react';
import { FormControl, Select, MenuItem } from '@mui/material';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';

var KLanguageSwitcher = function (_a) {
    var className = _a.className, currentLocale = _a.currentLocale, locales = _a.locales, onChange = _a.onChange, sx = _a.sx, color = _a.color;
    var t = useTranslation("refront-components").t;
    return (React__default.createElement(FormControl, { className: clsx("KLanguageSwitcher", className), "data-testid": "KLanguageSwitcher", sx: sx },
        React__default.createElement(Select, { value: currentLocale, onChange: onChange, autoWidth: true, MenuProps: { disableScrollLock: true, className: "KLanguageSwitcher-Menu" }, variant: "standard", sx: { color: color } }, locales.map(function (locale, index) {
            return (React__default.createElement(MenuItem, { key: index, value: locale }, t("components.KLanguageSwitcher.".concat(locale, ".label"))));
        }))));
};

export { KLanguageSwitcher as default };
//# sourceMappingURL=index.js.map
